"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _imColor = require("./imColor");
Object.keys(_imColor).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _imColor[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _imColor[key];
    }
  });
});